var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3092_24286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58268 4.16666H9.94468C12.4841 4.16666 13.7537 4.16666 14.2357 4.62273C14.6523 5.01696 14.837 5.59772 14.7245 6.16017C14.5944 6.81084 13.5578 7.54404 11.4846 9.01043L8.09745 11.4062C6.02427 12.8726 4.98767 13.6058 4.85755 14.2565C4.74506 14.8189 4.9297 15.3997 5.34632 15.7939C5.8283 16.25 7.09798 16.25 9.63735 16.25H10.416M6.66602 4.16666C6.66602 5.54737 5.54673 6.66666 4.16602 6.66666C2.7853 6.66666 1.66602 5.54737 1.66602 4.16666C1.66602 2.78594 2.7853 1.66666 4.16602 1.66666C5.54673 1.66666 6.66602 2.78594 6.66602 4.16666ZM18.3327 15.8333C18.3327 17.214 17.2134 18.3333 15.8327 18.3333C14.452 18.3333 13.3327 17.214 13.3327 15.8333C13.3327 14.4526 14.452 13.3333 15.8327 13.3333C17.2134 13.3333 18.3327 14.4526 18.3327 15.8333Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3092_24286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "9b8f3e23f3e58f35e491e4e4143a799f.svg";
export { ForwardRef as ReactComponent };